// Hook uruchamia czyszczenie danych demo (TRUNCATE wybranych tabel + cleanup).
// POST /api/ui/core/panel/setup/clean-demo-data

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

interface IResponse extends ICommandResponseSuccess {
  data?: { message: string };
}

const postCleanDemoData = (): Promise<IResponse> =>
  axios.post('/core/panel/setup/clean-demo-data', {});

export const usePostCleanDemoData = (options?: UseMutationOptions<IResponse, IError, void>) =>
  useMutation(() => postCleanDemoData(), options);
